import { useMakeLocalizedText } from '../LocaleText';
import { LocaleText } from '../LocaleText';
import { CloseIcon } from './icons';

export const Header = ({ onClose }: { onClose: () => void }) => {
  const makeLocalizedText = useMakeLocalizedText();

  return (
    <div className="og-dialog-header">
      <h1 id="og-dialog-title" tabIndex={-1}>
        <LocaleText t="title" />
      </h1>
      <button className="og-dialog-close" onClick={onClose} aria-label={makeLocalizedText('close')}>
        <CloseIcon />
      </button>
    </div>
  );
};
